



































import { Component, Vue } from 'vue-property-decorator';
// @ts-ignore
import ro from '/node_modules/svg-country-flags/svg/ro.svg';
// @ts-ignore
import us from '/node_modules/svg-country-flags/svg/us.svg';
// @ts-ignore
import ru from '/node_modules/svg-country-flags/svg/ru.svg';
// @ts-ignore
import de from '/node_modules/svg-country-flags/svg/de.svg';
import {FmvAvatar} from 'fmv-avatar';
import {dispatchSetUserLanguage} from '@/store/main/actions';

@Component({
  components: {
    FmvAvatar,
  },
})
export default class I18nDropdown extends Vue {
  public navbar = true;
  public flags = {
    ru,
    en: us,
    de,
  };
  public locales = [
    { code: 'ru', iso: 'ru-EU', file: 'ru.json', title: 'Русский' },
    { code: 'en', iso: 'en-US', file: 'en.json', title: 'English' },
    { code: 'de', iso: 'de-EU', file: 'de.json', title: 'Deutsche' },
  ];

  public async switchLocalePath(locale) {
    this.$root.$i18n.locale = locale;
    await dispatchSetUserLanguage(this.$store, {language: locale});
    window.location.reload();
  }
}
